export const SOCKET_RESERVE_CREATED = 'SOCKET_RESERVE_CREATED';
export const SOCKET_RESERVE_CONFIRMATION = 'SOCKET_RESERVE_CONFIRMATION';
export const SOCKET_RECONNECT = 'SOCKET_RECONNECT';
export const SET_SOCKET_CONNECT_STATUS = 'SET_SOCKET_CONNECT_STATUS';
